<template>
  <figure
    v-if="src"
    class="video aspect-video"
    :class="{ 'is-visible': visible }"
  >
    <video
      v-if="src"
      ref="video"
      class="aspect-video bg-scheme-main-bis"
      autoplay
      muted
      loop
      playsinline
      @loadeddata="onPlay"
      @play="onPlay"
      @playing="onPlay"
    >
      <source v-if="src" :src="src" type="video/mp4" />
    </video>
  </figure>
</template>

<script lang="ts" setup>
import type { MediaVideoCantoFragment } from '#graphql-operations'
import { CANTO_VIDEO_BASE_URL } from '~/helpers/canto'

const props = defineProps<MediaVideoCantoFragment>()

const video = ref<HTMLVideoElement>()
const visible = ref(false)

const src = computed(
  () =>
    `${CANTO_VIDEO_BASE_URL}/video_${props.assetId}?content-disposition=inline`,
)

onMounted(() => {
  if (video.value && video.value.readyState !== 0) {
    visible.value = true
  }
})

function onPlay() {
  visible.value = true
}

// Exposing methods for external use
defineExpose({
  play: () => video.value?.play(),
  pause: () => video.value?.pause(),
})
</script>

<style lang="postcss">
.video {
  &.has-loading-transition {
    opacity: 0.04;
    transition: 0.8s;
    &.is-visible {
      opacity: 1;
    }
  }

  video {
    width: 100%;
    display: block;
  }
  video::-webkit-media-controls-start-playback-button {
    display: none;
  }
}
</style>
